import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  DocumentInstancesSliceState,
  GetDocumentInstancesPayload,
  GetDocumentInstancesResponse,
} from '@/domains/documents/store/types/DocumentsInstancesSlice';

const initialState: DocumentInstancesSliceState = {
  data: {
    listings: [],
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 20,
    },
  },
  statuses: {
    isLoading: false,
    isError: false,
  },
};

const documentInstancesSlice = createSlice({
  name: 'documentInstances',
  initialState,
  reducers: {
    getDocumentInstanceList: (_, _action: PayloadAction<GetDocumentInstancesPayload>) => {},
    incrementDocumentInstancesPage: (state, _action: PayloadAction<GetDocumentInstancesPayload>) => {
      state.data.pagination.page++;
    },
    getDocumentInstanceListSuccess: (
      state,
      {
        payload: { shouldRewrite = true, data },
      }: PayloadAction<{ shouldRewrite?: boolean; data: GetDocumentInstancesResponse }>,
    ) => {
      const listingsArray = Array.isArray(data.listings) ? data.listings : [data.listings];

      if (shouldRewrite) {
        state.data.listings = [...listingsArray];
        state.data.pagination = data.pagination;
      } else {
        state.data.listings = [...state.data.listings, ...listingsArray];
        state.data.pagination = data.pagination;
      }

      state.statuses.isLoading = false;
    },
    startLoadingDocumentInstanceListData: (state) => {
      state.statuses.isLoading = true;
    },
    getDocumentInstanceListDataError: (state) => {
      state.statuses.isLoading = false;
      state.statuses.isError = true;
    },
    resetDocumentInstancesSlice: () => initialState,
  },
});

export const {
  getDocumentInstanceList,
  getDocumentInstanceListSuccess,
  startLoadingDocumentInstanceListData,
  getDocumentInstanceListDataError,
  resetDocumentInstancesSlice,
  incrementDocumentInstancesPage,
} = documentInstancesSlice.actions;

export const documentInstancesReducer = documentInstancesSlice.reducer;
export const documentInstancesReducerPath = documentInstancesSlice.reducerPath;
